<app-spinner></app-spinner>
<form [formGroup]="smtpForm">
	<div class="bg-white dark:bg-gray-700 rounded-lg shadow p-4 w-full">
		<h2 class="font-avertaBold text-gray-800 dark:text-gray-200 mb-4">
			SMTP Configuration
		</h2>

		<div
			class="space-y-4 min-h-60 h-[calc(100vh-255px)] scrollbar-thin scrollbar-thumb-[#000733]/40 dark:scrollbar-thumb-[#ffffff]/20 pr-1 scrollbar-track-transparent overflow-y-scroll"
		>
			<!-- Note Section - Full width -->
			<div class="mb-4">
				<p
					class="text-sm text-[#ba7e1b] bg-[#F5A623]/30 p-3 rounded-lg"
				>
					<b class="font-avertaBold">Note!</b> SMTP configuration are
					used for sending emails.
				</p>
			</div>

			<!-- Grid container for form fields -->
			<div class="grid grid-cols-1 md:grid-cols-2 gap-4">
				<!-- FROM Field -->
				<div class="space-y-1">
					<label
						for="from"
						class="block text-sm font-avertaBold text-gray-700 dark:text-gray-300"
					>
						FROM <span class="text-red-600">*</span>
					</label>
					<input
						type="text"
						id="from"
						formControlName="from"
						class="bg-white w-full duration-200 border border-[#E2E2E2] py-2 px-4 rounded-lg dark:bg-gray-600 dark:border-gray-500 dark:text-white focus:outline-none focus:ring-0 focus:border-gray-700 placeholder-gray-500 dark:placeholder-gray-500"
						[ngClass]="{
							'border-red-600 dark:border-red-500':
								smtpForm.get('from')?.invalid &&
								smtpForm.get('from')?.touched
						}"
						placeholder="Email Id From"
					/>
					@if (
						smtpForm.get('from')?.hasError('required') &&
						smtpForm.get('from')?.touched
					) {
						<div>
							<span class="text-red-600 dark:text-red-300 text-xs"
								>From is required.</span
							>
						</div>
					}
					@if (
						smtpForm.get('from')?.hasError('email') &&
						smtpForm.get('from')?.touched
					) {
						<div>
							<span class="text-red-600 dark:text-red-300 text-xs"
								>Invalid From email.</span
							>
						</div>
					}
				</div>

				<!-- HOST Field -->
				<div class="space-y-1">
					<label
						for="host"
						class="block text-sm font-avertaBold text-gray-700 dark:text-gray-300"
					>
						HOST <span class="text-red-600">*</span>
					</label>
					<input
						type="text"
						id="host"
						formControlName="host"
						class="bg-white w-full duration-200 border border-[#E2E2E2] py-2 px-4 rounded-lg dark:bg-gray-600 dark:border-gray-500 dark:text-white focus:outline-none focus:ring-0 focus:border-gray-700 placeholder-gray-500 dark:placeholder-gray-500"
						[ngClass]="{
							'border-red-600 dark:border-red-500':
								smtpForm.get('host')?.invalid &&
								smtpForm.get('host')?.touched
						}"
						placeholder="Host Info"
					/>
					@if (
						smtpForm.get('host')?.hasError('required') &&
						smtpForm.get('host')?.touched
					) {
						<div>
							<span class="text-red-600 dark:text-red-300 text-xs"
								>Host is required.</span
							>
						</div>
					}
				</div>

				<!-- SMTP PORT Field -->
				<div class="space-y-1">
					<label
						for="port"
						class="block text-sm font-avertaBold text-gray-700 dark:text-gray-300"
					>
						SMTP PORT <span class="text-red-600">*</span>
					</label>
					<input
						type="text"
						id="port"
						formControlName="port"
						class="bg-white w-full duration-200 border border-[#E2E2E2] py-2 px-4 rounded-lg dark:bg-gray-600 dark:border-gray-500 dark:text-white focus:outline-none focus:ring-0 focus:border-gray-700 placeholder-gray-500 dark:placeholder-gray-500"
						[ngClass]="{
							'border-red-600 dark:border-red-500':
								smtpForm.get('port')?.invalid &&
								smtpForm.get('port')?.touched
						}"
						placeholder="SMTP Port"
					/>
					@if (
						smtpForm.get('port')?.hasError('required') &&
						smtpForm.get('port')?.touched
					) {
						<div>
							<span class="text-red-600 dark:text-red-300 text-xs"
								>SMTP Port is required.</span
							>
						</div>
					}
				</div>

				<!-- USER NAME Field -->
				<div class="space-y-1">
					<label
						for="user_name"
						class="block text-sm font-avertaBold text-gray-700 dark:text-gray-300"
					>
						USER NAME <span class="text-red-600">*</span>
					</label>
					<input
						type="text"
						id="user_name"
						formControlName="user_name"
						class="bg-white w-full duration-200 border border-[#E2E2E2] py-2 px-4 rounded-lg dark:bg-gray-600 dark:border-gray-500 dark:text-white focus:outline-none focus:ring-0 focus:border-gray-700 placeholder-gray-500 dark:placeholder-gray-500"
						[ngClass]="{
							'border-red-600 dark:border-red-500':
								smtpForm.get('user_name')?.invalid &&
								smtpForm.get('user_name')?.touched
						}"
						placeholder="User Name"
					/>
					@if (
						smtpForm.get('user_name')?.hasError('required') &&
						smtpForm.get('user_name')?.touched
					) {
						<div>
							<span class="text-red-600 dark:text-red-300 text-xs"
								>User name is required.</span
							>
						</div>
					}
				</div>

				<!-- PASSWORD Field -->
				<div class="space-y-1">
					<label
						for="password"
						class="block text-sm font-avertaBold text-gray-700 dark:text-gray-300"
					>
						PASSWORD <span class="text-red-600">*</span>
					</label>
					<input
						type="text"
						id="password"
						formControlName="password"
						class="bg-white w-full duration-200 border border-[#E2E2E2] py-2 px-4 rounded-lg dark:bg-gray-600 dark:border-gray-500 dark:text-white focus:outline-none focus:ring-0 focus:border-gray-700 placeholder-gray-500 dark:placeholder-gray-500"
						[ngClass]="{
							'border-red-600 dark:border-red-500':
								smtpForm.get('password')?.invalid &&
								smtpForm.get('password')?.touched
						}"
						placeholder="Password"
					/>
					@if (
						smtpForm.get('password')?.hasError('required') &&
						smtpForm.get('password')?.touched
					) {
						<div>
							<span class="text-red-600 dark:text-red-300 text-xs"
								>Password is required.</span
							>
						</div>
					}
				</div>

				<input
					type="hidden"
					name="MailSettingsNumber"
					formControlName="MailSettingsNumber"
				/>
				<input type="hidden" name="subject" formControlName="subject" />

				<!-- Enable SSL Field - Full width on mobile, could span one column on desktop -->
				<div class="space-y-1">
					<label
						class="block text-sm font-avertaBold text-gray-700 dark:text-gray-300 mb-2"
					>
						Enable SSL <span class="text-red-600">*</span>
					</label>
					<label class="inline-flex items-center cursor-pointer">
						<input
							type="checkbox"
							class="sr-only peer"
							formControlName="ssl"
							(change)="onCheckboxChange('ssl', $event)"
						/>
						<div
							class="relative w-11 h-6 bg-gray-300 peer-focus:outline-none peer-focus:ring-2 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600"
							[class.peer-checked]="smtpForm.get('ssl')?.value"
						></div>
						<span
							class="ml-2 text-sm text-gray-700 dark:text-gray-300"
							>SSL check/uncheck</span
						>
					</label>
				</div>
			</div>
			<!-- End grid container -->
		</div>
	</div>
</form>
